import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LempoleSite from './components/LempoleSite';
import BlogIndex from './components/BlogIndex';
import BlogPost from './components/BlogPost';
import VigneronPage from './components/VigneronPage';
import InstagramPreview from './components/InstagramPreview';
import EditorialCalendar from './components/EditorialCalendar';
import TermsPage from './components/TermsPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LempoleSite />} />
          <Route path="/vigneron" element={<VigneronPage />} />
          <Route path="/instagram-preview" element={<InstagramPreview />} />
          <Route path="/editorial-calendar" element={<EditorialCalendar />} />
          <Route path="/diario" element={<BlogIndex />} />
          <Route path="/diario/:slug" element={<BlogPost />} />
          <Route path="/termini" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
